import React from "react";
import { Link, useLocation } from "react-router-dom";

interface PreLoginMenuProps {
  handleLoginRedirect: () => void;
}

const PreLoginMenu: React.FC<PreLoginMenuProps> = ({ handleLoginRedirect }) => {
  const location = useLocation();
  return (
    <div className="right-menu">
      <Link
        to="/signup"
        className={location.pathname === "/signup" ? "active" : ""}
      >
        Sign up
      </Link>
      <button className="btn btn-primary" onClick={handleLoginRedirect}>
        Login
      </button>
    </div>
  );
};

export default PreLoginMenu;
